import React from 'react';
import css from './StudentIntakeHeader.scss';

export default class StaffIntakeHeader extends React.Component {
  render() {
    return (
      <>
        <section className={css['instruction-block']}>
          <h1>Student Intake</h1>
        </section>
        <hr className={css['divider']} />
      </>
    );
  }
}
